var MAX_NAME_LENGTH = 255;

export { MAX_NAME_LENGTH };
